import React from 'react';
import { Panel, PanelGroup } from 'react-resizable-panels';
import CustomResizeHandle from '@/app/components/CustomResizeHandle';
import RoutesGrid from '../PlanningRoutes/RoutesGrid';
import PlanningTasksGrid from '../PlanningTasks/PlanningTasksGrid';
import { StyledGridContainerBox } from '@/app/components/CustomResizeHandle/CustomResizeHandle';

const DEFAULT_PANEL_SIZE = 50;
const MIN_PANEL_SIZE = 10;

interface IOwnProps {
    handleSetRoutesGridApi: (api: any) => void;
    handleSetTasksGridApi: (api: any) => void;
    dragAndDropOptionsRoutes: any;
    dragAndDropOptionsTasks: () => any;
    handleClearTask: () => void;
    handleClearRoute: () => void;
    refetchGridsData: () => void;
}

const GridSection = ({
    handleSetRoutesGridApi,
    handleSetTasksGridApi,
    dragAndDropOptionsRoutes,
    dragAndDropOptionsTasks,
    handleClearTask,
    handleClearRoute,
    refetchGridsData,
}: IOwnProps) => (
    <PanelGroup direction="vertical" autoSaveId="persistence-vertical">
        <Panel defaultSize={DEFAULT_PANEL_SIZE} minSize={MIN_PANEL_SIZE}>
            <StyledGridContainerBox>
                <RoutesGrid
                    handleSetApi={handleSetRoutesGridApi}
                    dragAndDropOptions={dragAndDropOptionsRoutes}
                    handleClearTask={handleClearTask}
                />
            </StyledGridContainerBox>
        </Panel>

        <CustomResizeHandle direction="vertical" />

        <Panel defaultSize={DEFAULT_PANEL_SIZE} minSize={MIN_PANEL_SIZE}>
            <StyledGridContainerBox>
                <PlanningTasksGrid
                    handleSetApi={handleSetTasksGridApi}
                    dragAndDropOptions={() => ({
                        ...dragAndDropOptionsTasks(),
                        onRowDragEnter: () => {
                            handleClearTask();
                            handleClearRoute();
                        },
                    })}
                    handleClearTask={handleClearTask}
                    refetchGridsData={refetchGridsData}
                />
            </StyledGridContainerBox>
        </Panel>
    </PanelGroup>
);

export default GridSection;
